import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';

/**
 * OptimisationAssolement
 *
 * Fil de fer (Phase 1) : la navigation est câblée, le contenu arrive en
 * Phase 6.
 * Contenu prévu : optimisation_assol.js, sidebar vide
 */
export default function OptimisationAssolement() {
  const { idExploit } = useOAD();

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2026-2027"
        niveau2="optimisation-assolement"
        niveau3={null}
        idExploit={idExploit}
      />
      <main className="oad-cards">
        <div className="oad-card oad-card-placeholder">
          <h2>OptimisationAssolement</h2>
          <p>optimisation_assol.js, sidebar vide</p>
        </div>
      </main>
    </div>
  );
}
